import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfPoint,
  PdfFont,
  PdfBrush,
  ETextAlign,
  PageGen,
} from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import { calcGridRectsEx } from '../../pdf/board/grid';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/label';
import '../../pdf/draw/cut';

/**
 * Policka (Checklist) - Checklist cards with checkboxes
 *
 * Layout: 3 landscape pages with increasing column counts (2, 3, 4).
 * Each column has a "Seznam" header and grid of items with checkboxes.
 *
 * Migrated from C# EduFrame.Img10.Generators.Policka
 */
export class Policka implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 24;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const headerSize = PdfUnit.FromMillimeters(20);
    const betweenSize = PdfUnit.FromMillimeters(5);
    const checkSize = PdfUnit.FromMillimeters(8);
    const gridMargin = PdfUnit.FromMillimeters(2);

    const sortedItems = [...opts.list].sort((a, b) => {
      const aText = a.left.getText() ?? '';
      const bText = b.left.getText() ?? '';
      return aText.localeCompare(bText);
    });

    const allTexts = sortedItems.map((item) => item.left.getText() ?? '');

    const {lang} = opts.data;
    const listLabel = lang.Generator_List ?? 'Seznam';

    for (let index = 0; index < 3; index++) {
      const page = pdf.addPage(true); // landscape
      const parts = 2 + index;
      const margin = PdfUnit.FromMillimeters(Math.max(20 - parts * 5, 5));

      for (let p = 0; p < parts; p++) {
        const baseRect = new PdfRect(
          (p * PdfSize.A4.height) / parts,
          0,
          PdfSize.A4.height / parts,
          PdfSize.A4.width
        );
        page.drawRectangle(GUtil.cutPen, null, baseRect);
        page.drawString(
          listLabel,
          GUtil.baseFont,
          PdfBrush.Black,
          null,
          new PdfRect(baseRect.x + margin, baseRect.top, PdfUnit.FromMillimeters(100), headerSize),
          ETextAlign.BottomLeft
        );

        const rect = new PdfRect(
          baseRect.x + margin,
          baseRect.y + margin + headerSize,
          baseRect.width - 2 * margin,
          baseRect.height - 2 * margin - headerSize
        );

        const grid = calcGridRectsEx(sortedItems.length, rect, gridMargin);
        const labelFont = page.adjustFontMulti(
          allTexts.map((t) => [t]),
          GUtil.baseFont,
          new PdfSize(grid.cellSize.width, grid.cellSize.height)
        );

        for (let i = 0; i < grid.rects.length; i++) {
          const r = grid.rects[i];

          page.drawLabel(sortedItems[i].left, { rect: r, font: labelFont });

          const checkRect = new PdfRect(r.right - checkSize - 3, r.top + 3, checkSize, checkSize);
          page.drawRectangle(null, PdfBrush.White, checkRect);
          page.drawRectangle(GUtil.basePen, null, checkRect);
        }
      }
    }
  }
}
